import { useTranslation } from 'react-i18next'

import Button from '../../../Button'
import { QA_NAME_REQUEST_PROFILE_TAB_ACTIVITIES_ADD_NEW_PHASE } from '../RequestProfileTabActivities.constants'

import * as styles from './RequestProfileTabActivitiesAddPhaseButton.module.css'

import PlusIcon from '../../../../icons/plus.svg'

function RequestProfileTabActivitiesAddPhaseButton({
  className = styles.RequestProfileTabActivitiesAddPhaseButton,
  isLimitReached,
  onClick,
}) {
  const { t } = useTranslation()

  return (
    <Button.Contained
      isLight
      beforeIconProps={{ Icon: PlusIcon }}
      className={className}
      disabled={isLimitReached}
      qaName={QA_NAME_REQUEST_PROFILE_TAB_ACTIVITIES_ADD_NEW_PHASE}
      text={t('RequestProfileTabActivities.AddNewPhaseBtnKey')}
      tooltip={
        isLimitReached
          ? t('RequestProfileTabActivities.PhasesLimitReachedTooltipKey')
          : undefined
      }
      onClick={onClick}
    />
  )
}

export default RequestProfileTabActivitiesAddPhaseButton
